export const TABLE_IDENTIFIER_IPR_BROKING_TOOLS_ID = 5;
export const TABLE_IDENTIFIER_IPR_COVERHOLDER_SUITE_ID = 7;